(() => {
  if (window.semboniaCollectionControlsReady) return;
  window.semboniaCollectionControlsReady = true;
  const initialized = new WeakSet();
  const observedRoots = new WeakSet();
  const observedHeaders = new WeakSet();
  const filterRows = new WeakSet();
  let filterLayerObserver;
  function restoreCollectionLayer() {
    if (!document.body?.classList.contains('page-collection')) return;
    const main = document.getElementById('MainContent');
    if (!main || document.querySelector('.sq-filter-main.sparq-filter-open') || document.body.classList.contains('sparq-filter-is-open')) return;
    // Sparq's outside/View Items handler leaves this inline !important layer
    // on the body grid item. Remove only its known drawer elevation.
    if (main.style.getPropertyValue('z-index').trim() === '99') main.style.removeProperty('z-index');
  }
  let queued = false;
  window.semboniaScrollToCollectionResults = () => {
    if (!document.body?.classList.contains('page-collection')) return;
    const root = document.querySelector('.sq-app');
    if (!root) return;
    const headerHeight = document.querySelector('.section-header')?.getBoundingClientRect().height || 0;
    const firstCard = root.querySelector('.sparq-container .sparq-card');
    const toolbarHeight = root.querySelector('.sembonia-collection-toolbar')?.getBoundingClientRect().height || 0;
    const top = Math.max(0, (firstCard || root).getBoundingClientRect().top + window.scrollY - headerHeight - (firstCard ? toolbarHeight : 0));
    if (window.semboniaLenis) {
      window.semboniaLenis.resize();
      window.semboniaLenis.scrollTo(top, { immediate: true, force: true });
    } else window.scrollTo({ top, behavior: 'instant' });
  };
  let cancelResultAlignment;
  window.semboniaAlignFilteredResults = () => {
    cancelResultAlignment?.();
    const grid = document.querySelector('body.page-collection .sparq-container');
    if (!grid) return;
    let timer;
    let cancelled = false;
    const align = () => {
      if (cancelled) return;
      restoreCollectionLayer();
      window.semboniaScrollToCollectionResults();
    };
    const scheduleAlignment = () => {
      clearTimeout(timer);
      timer = setTimeout(align, 180);
    };
    const observer = new MutationObserver(scheduleAlignment);
    observer.observe(grid, {childList:true, subtree:true});
    const deadline = setTimeout(() => { align(); cancel(); }, 4000);
    const cancel = () => {
      cancelled = true;
      clearTimeout(timer); clearTimeout(deadline); observer.disconnect();
      window.removeEventListener('wheel', cancel, true);
      window.removeEventListener('touchstart', cancel, true);
      window.removeEventListener('keydown', cancel, true);
      cancelResultAlignment = null;
    };
    cancelResultAlignment = cancel;
    window.addEventListener('wheel', cancel, {capture:true, passive:true});
    window.addEventListener('touchstart', cancel, {capture:true, passive:true});
    window.addEventListener('keydown', cancel, true);
    requestAnimationFrame(() => requestAnimationFrame(align));
    scheduleAlignment();
  };
  function update() {
    queued = false;
    document.querySelectorAll('.sq-filter-main .sq-accordion').forEach(row => {
      if (filterRows.has(row)) return;
      const header = row.querySelector('.sq-accordion-header');
      if (!header) return;
      filterRows.add(row);
      row.dataset.semboniaCollapsed = 'true';
      header.setAttribute('aria-expanded', 'false');
      header.setAttribute('role', 'button');
      header.tabIndex = 0;
      const toggle = event => {
        event.preventDefault();
        const collapsed = row.dataset.semboniaCollapsed !== 'true';
        row.dataset.semboniaCollapsed = String(collapsed);
        header.setAttribute('aria-expanded', String(!collapsed));
        // A native-closed accordion has no body yet: allow Vue's click handler
        // to mount it. Once mounted, keep it available for category filtering.
        if (collapsed || !row.classList.contains('sq-close')) event.stopImmediatePropagation();
      };
      header.addEventListener('click', toggle, true);
      header.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          header.click();
        }
      });
    });
    if (document.body?.classList.contains('page-collection')) {
      try {
        const key = window.location.pathname + window.location.search;
        const root = document.querySelector('.sq-app');
        if (sessionStorage.getItem('sembonia-category-scroll') === key && root?.querySelector('.sparq-card')) {
          sessionStorage.removeItem('sembonia-category-scroll');
          window.semboniaScrollToCollectionResults();
        }
      } catch (_) {}
      document.querySelectorAll('.sq-pagination .sq-navigation').forEach(nav => {
        const numbers = nav.querySelector('.sq-page-mobile')?.textContent.match(/\d+/g);
        if (!numbers || numbers.length < 2) return;
        const [current, total] = numbers.map(Number);
        [['.sq-previous', current <= 1, 'Previous page'], ['.sq-next', current >= total, 'Next page']].forEach(([selector, disabled, label]) => {
          const link = nav.querySelector(selector);
          if (!link) return;
          link.setAttribute('aria-label', label);
          link.setAttribute('aria-disabled', String(disabled));
          link.setAttribute('tabindex', disabled ? '-1' : '0');
        });
      });
      const header = document.querySelector('.section-header');
      if (header) {
        document.documentElement.style.setProperty('--sembonia-collection-header-height', `${header.getBoundingClientRect().height}px`);
        if (window.ResizeObserver && !observedHeaders.has(header)) {
          observedHeaders.add(header);
          new ResizeObserver(schedule).observe(header);
        }
      }
    }
    document.querySelectorAll(':is(.page-collection, .page-search) .sq-app .filter-wrapper').forEach(wrapper => {
      const scroller = wrapper.querySelector('.filter-scroll');
      if (!scroller) return;
      if (!initialized.has(scroller)) {
        initialized.add(scroller);
        scroller.addEventListener('scroll', schedule, { passive: true });
        if (window.ResizeObserver) {
          const observer = new ResizeObserver(schedule);
          observer.observe(scroller);
          const labels = scroller.querySelector('.isotope-filters');
          if (labels) observer.observe(labels);
        }
      }
      // Full-width scrolling replaces the old shortened half-label viewport.
      scroller.style.removeProperty('--sembonia-category-peek');
      const mobile = window.matchMedia('(max-width:809.98px)').matches;
      const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      const left = Math.max(0, Math.min(scroller.scrollLeft, maxScroll));
      scroller.dataset.scrollLeft = String(mobile && left > 1);
      scroller.dataset.scrollRight = String(mobile && maxScroll - left > 1);
    });
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }
  function start() {
    if (document.body?.classList.contains('page-collection') && !filterLayerObserver) {
      const main = document.getElementById('MainContent');
      if (main) {
        filterLayerObserver = new MutationObserver(restoreCollectionLayer);
        filterLayerObserver.observe(main, { attributes:true, attributeFilter:['style'] });
        filterLayerObserver.observe(document.body, { attributes:true, attributeFilter:['class'] });
      }
      restoreCollectionLayer();
    }
    document.querySelectorAll('.sq-app').forEach(root => {
      if (observedRoots.has(root)) return;
      observedRoots.add(root);
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    });
    schedule();
  }
  document.addEventListener('click', event => {
    if (event.target.closest('body.page-collection .sq-pagination [aria-disabled="true"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  // Close consistently without passing an outside click through to the page.
  window.addEventListener('click', event => {
    const panel = document.querySelector('.sq-filter-main.sparq-filter-open');
    if (!panel || !(event.target instanceof Element)) return;
    const target = event.target;
    if (!panel.contains(target) || target.closest('.sq-overlay, .sq-filter-bottom, .sq-filter-header-clear .sq-cross, .sq-cross.custom-closs-button')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      panel.dispatchEvent(new CustomEvent('sembonia:close-filter', { bubbles:true }));
    }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.addEventListener('resize', schedule);
  document.fonts?.ready.then(schedule);
  document.addEventListener('shopify:section:load', start);
})();
